export default __webpack_public_path__ + "static/media/mastercard.775547e4.svg";